import { useNavigate, useSearchParams } from "react-router-dom";
import { Package, Monitor, ChevronLeft } from "lucide-react";
import OSPatchManagement from "./OSPatchManagement";
import PatchManagement from "./PatchManagement";
import Jobs from "../Settings/Scheduler/Jobs";


export default function PatchJobsMain() {
    const [searchParams, setSearchParams] = useSearchParams();
    const prev = searchParams.get("prev") || "application";
    const navigate = useNavigate();




    // Read from URL, default to 'application' if not set or invalid
    const activeTab = searchParams.get("tab") === "os" ? "os" : searchParams.get("tab") === "script" ? "script" : "application";

    // Update URL when switching tabs while preserving other params (like 'prev')
    const handleTabChange = (tab: 'application' | 'os'| 'script') => {
        setSearchParams((prevParams) => {
            prevParams.set("tab", tab);
            return prevParams;
        });
    };

    return (
        <div className="flex flex-col h-full">
            {/* Header / Tabs Navigation */}
            <div className="flex items-center gap-3 bg-gray-800 p-2 border border-gray-700 shadow-sm">

                <button
                    onClick={() => navigate(`/patching?tab=${prev}`)}
                    className="flex items-center gap-2 px-2 py-2 bg-gray-900 hover:bg-gray-700 border border-gray-700 hover:border-gray-600 rounded-lg text-gray-300 hover:text-white text-[11px] font-bold uppercase tracking-widest transition-all shadow-sm group"
                >
                    <ChevronLeft size={14} className="text-gray-200 group-hover:text-orange-400 transition-colors" />
                </button>

                {/* Tabs */}
                <div className="flex bg-gray-900/80 p-1 border rounded-lg border-gray-700/50">
                    <button
                        onClick={() => handleTabChange('application')}
                        className={`flex items-center gap-2 px-5 py-2 rounded-md text-[11px] font-bold uppercase tracking-widest transition-all duration-300 border ${activeTab === 'application'
                            ? 'bg-gray-800 border-gray-600 text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-200 hover:text-gray-300 hover:bg-gray-800/50'
                            }`}
                    >
                        <Package size={14} />
                        Application Jobs
                    </button>
                    <button
                        onClick={() => handleTabChange('os')}
                        className={`flex items-center gap-2 px-5 py-2 rounded-md text-[11px] font-bold uppercase tracking-widest transition-all duration-300 border ${activeTab === 'os'
                            ? 'bg-gray-800 border-gray-600 text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-200 hover:text-gray-300 hover:bg-gray-800/50'
                            }`}
                    >
                        <Monitor size={14} />
                        OS Patching Jobs
                    </button>
                     <button
                        onClick={() => handleTabChange('script')}
                        className={`flex items-center gap-2 px-5 py-2 rounded-md text-[11px] font-bold uppercase tracking-widest transition-all duration-300 border ${activeTab === 'script'
                            ? 'bg-gray-800 border-gray-600 text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-200 hover:text-gray-300 hover:bg-gray-800/50'
                            }`}
                    >
                        <Monitor size={14} />
                        Script Jobs
                    </button>


                </div>
            </div>

            {/* Tab Content */}
            <div className="flex-1 px-3 pb-20">
                {activeTab === 'application' && <PatchManagement />}
                {activeTab === 'os' && <OSPatchManagement />}
                {activeTab === 'script' && <Jobs scriptjobs={true} />}

            </div>
        </div>
    );
}